import { render, staticRenderFns } from "./menu-version.vue?vue&type=template&id=9b119ff8"
import script from "./menu-version.vue?vue&type=script&lang=js"
export * from "./menu-version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports